import { render, staticRenderFns } from "./RoleCreate.vue?vue&type=template&id=820198c8"
import script from "./RoleCreate.vue?vue&type=script&lang=ts"
export * from "./RoleCreate.vue?vue&type=script&lang=ts"
import style0 from "./RoleCreate.vue?vue&type=style&index=0&id=820198c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports